<template>
  <div class="container" :style="{ 'background-color': bgColor, 'border-color': color }">
    <Icon medium :name="iconName" :color="color" />
    <div class="text">
      {{ text }}
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import Icon from '@/components/foundation/Icon.vue';
import { colours } from '@/ux/colours';

const comp = defineComponent({
  name: 'MessageBanner',
  components: {
    Icon,
  },
  props: {
    type: {
      default: 'warning',
      validator: (value) => ['warning', 'error', 'neutral', 'info'].indexOf(value) > -1,
    },
    text: { type: String, default: null },
  },
  data() {
    return {
      presetColors: {
        warning: {
          color: colours.ALERT.ALERT_500,
          bgColor: colours.ALERT.ALERT_100,
        },
        error: {
          color: colours.ERROR.ERROR_500,
          bgColor: colours.ERROR.ERROR_100,
        },
        neutral: {
          color: '#ADADAD',
          bgColor: '#FFFFFF',
        },
        info: {
          color: colours.ACTION.ACTION_500,
          bgColor: colours.ACTION.ACTION_100,
        },
      },
      iconMap: {
        warning: 'alertCircle',
        error: 'alert-triangle',
        neutral: 'hourglass',
        info: 'clock',
      },
    };
  },
  computed: {
    iconName() {
      return this.iconMap[this.type];
    },
    color() {
      return this.presetColors[this.type].color;
    },
    bgColor() {
      return this.presetColors[this.type].bgColor;
    },
  },
});
export default comp;
</script>

<style lang="postcss" scoped>
.container {
  padding: var(--space-16);
  border-radius: var(--space-4);
  border: 1px solid;
  display: flex;
  flex-direction: row;
  margin-bottom: var(--space-24);

  .text {
    padding-left: var(--space-16);
    font-size: var(--x14);
    color: var(--text-primary);
    min-height: var(--space-18);
  }
}
</style>
